import { en } from './locales/en.js';
import { ru } from './locales/ru.js';
import { zhHans } from './locales/zh-Hans.js';

export const defaultNS = 'common';

export const resources = {
  en,
  ru,
  'zh-Hans': zhHans,
} as const;

export type I18nResourceTree = typeof ru;
export type I18nNamespace = keyof I18nResourceTree;
